import { takeEvery, put, select, call } from 'redux-saga/effects'
import { push } from 'connected-react-router'
import { stopSubmit, startSubmit } from 'redux-form/immutable'
import { Map } from 'immutable'
import actionTypes from '../actionTypes'
import actions from '../actions'
import selectors from '../selectors'
import { showError, showSuccess } from '../../toastr/utils'
import makeAPIRequest from '../../api/sagas'
import { ORG_INACTIVE_NOTIFICATIONS_ENDPOINT } from 'app/constants/api/orgInactiveNotifications'
import { ORG_INACTIVE_NOTIFICATIONS_CREATE_FORM as FORM_NAME } from 'app/constants/orgInactiveNotifications'
import { ORG_INACTIVE_NOTIFICATION_CREATE_SUCCESS } from 'app/constants/toastrMessages'
import { getViewOrganizationSettingsId } from '../../organizations/selectors'

export default function* postSaga() {
  yield takeEvery(actionTypes.ORG_INACTIVE_NOTIFICATIONS.POST.REQUEST, handlePostRequest)
}

export function* handlePostRequest({ payload: { data: values } }) {
  try {
    const pending = yield select(selectors.getPendingPost)
    if (!pending) {
      yield put(startSubmit(FORM_NAME))
      yield put(actions.setPending('post', true))
      const orgId = yield select(getViewOrganizationSettingsId)
      const {
        data: { data },
      } = yield call(makeAPIRequest, ORG_INACTIVE_NOTIFICATIONS_ENDPOINT(orgId), {
        method: 'POST',
        data: values,
      })
      yield put(actions.orgInactiveNotifications.post.success(data))
      const list = yield select(selectors.getList)
      const orders = list
        .insert(data.order - 1, Map(data))
        .map((notification, index) => ({ order: index + 1, id: notification.get('id') }))
      yield call(makeAPIRequest, `${ORG_INACTIVE_NOTIFICATIONS_ENDPOINT(orgId)}/set-order`, {
        method: 'POST',
        data: { orders },
      })
      showSuccess({ content: ORG_INACTIVE_NOTIFICATION_CREATE_SUCCESS })
      yield put(push(`/organizations/${orgId}/settings/inactive-notifications/`))
    }
  } catch (error) {
    showError()
    yield put(actions.orgInactiveNotifications.post.fail(error))
  } finally {
    yield stopSubmit(FORM_NAME)
  }
}
